@if (data) {
  <form [formGroup]="editIrisIdDialogForm" novalidate>
    <wcg-dialog title="Edit ContactID" class="w-full" [size]="data.size">
      <div class="w-full user-management-edit-iris-id__container" content>
        <div class="w-full flex flex-col gap-6">
          <div class="w-full flex flex-col">
            <ng-container
              [ngTemplateOutlet]="infoSpan"
              [ngTemplateOutletContext]="{
                propName: 'Name',
                propValue: data.name,
              }"
            />
            <ng-container
              [ngTemplateOutlet]="infoSpan"
              [ngTemplateOutletContext]="{
                propName: 'Email',
                propValue: data.email,
              }"
            />
          </div>
          <div class="w-full">
            <ng-container
              [ngTemplateOutlet]="inputFormField"
              [ngTemplateOutletContext]="{
                formControl: editIrisIdDialogForm.controls.legacy_id,
                props: {
                  label: 'Primary ContactID',
                  width: 'large',
                  type: 'text',
                  testId: 'legacy-id',
                },
              }"
            />
          </div>
          <div class="w-full">
            <ng-container
              [ngTemplateOutlet]="inputFormField"
              [ngTemplateOutletContext]="{
                formControl:
                  editIrisIdDialogForm.controls.additional_legacy_ids,
                props: {
                  label: 'Additional ContactIDs',
                  width: 'large',
                  type: 'text',
                  testId: 'additional-legacy-ids',
                  optionalMessage: 'Separate additional IDs with commas.',
                },
              }"
            />
          </div>
        </div>
      </div>

      <!---Dialog Footer-->
      <div tertiary>
        <wcg-button
          color="tertiary"
          data-testid="user-management-edit-iris-id__cancel-btn"
          (click)="close()"
          >Cancel</wcg-button
        >
      </div>
      <div primary>
        <wcg-button
          color="primary"
          data-testid="user-management-edit-iris-id__save-btn"
          [isDisabled]="false"
          (click)="save()"
          >Save</wcg-button
        >
      </div>
      <!---/Dialog Footer--->
    </wcg-dialog>

    <ng-template
      #inputFormField
      let-props="props"
      let-formControl="formControl"
    >
      <wcg-input-field
        [attr.data-testid]="
          'user-management-edit-iris-id__input-field-' + props.testId
        "
        [class]="props.class"
        [type]="props.type"
        [formControl]="formControl"
        [errorText]="
          formControl.hasError('numericError')
            ? formControl ===
              editIrisIdDialogForm.controls.additional_legacy_ids
              ? additionalIRISContactIdNumericError
              : primaryIRISContactIdNumericError
            : ''
        "
        [width]="props.width"
        [height]="props.height ?? 'default'"
        [label]="props.label"
      />
      @if (
        props.optionalMessage?.length > 0 &&
        !formControl.hasError("numericError")
      ) {
        <span class="text-bluegrey-13">{{ props.optionalMessage }}</span>
      }
    </ng-template>

    <ng-template #infoSpan let-propName="propName" let-propValue="propValue">
      <span
        class="user-management-edit-iris-id__info-span"
        [attr.data-testid]="
          'user-management-edit-iris-id__info-span-' + propName
        "
      >
        <strong class="user-management-edit-iris-id__info-span-title">
          {{ propName }}:</strong
        >
        {{ propValue }}
      </span>
    </ng-template>
  </form>
}
